// Input: '071.132.844-77'
// Output: '07113284477'
export const cleanCpf = (cpf: string): string => {
  return cpf.replace(/[.\-]/g, '')
}
